import React      from 'react';
import Soldermask from 'pu-react/components/Soldermask';

const Component = (props) => {
  if (!props.show) { return null; }
  return <Soldermask {...props} />;
};

Component.defaultProps = {
  show: true,
};

export default Component;
